import styled from 'styled-components';
import { CircularButton } from '@minerva-analytics/pantheon';
import InlineSVG from 'svg-inline-react';

import {
  YELLOW,
  BLUE,
  ORANGE,
  GREEN,
  WHITE,
  MEDIUM_GRAY,
} from 'root/theme';

const KIND = {
  E: YELLOW,
  M: BLUE,
  H: ORANGE,
  S: GREEN,
};

const CircularStartQuizButton = styled(CircularButton).attrs({
  diameter: `1.3rem`,
})`
  background: ${(props) => KIND[props.kind]};
  color: ${WHITE};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 9px;
  padding: 0.5rem;
`;

const CircularCheckmarkQuizButton = styled(CircularButton).attrs({
  diameter: `1.3rem`,
})`
  background-color: ${MEDIUM_GRAY};
  border: 1.5px solid ${MEDIUM_GRAY};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 10px;
  padding: 0rem;
`;

const CheckMarkSVG = styled(InlineSVG)`
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 8px;
    height: 8px;
  }
`;

export {
  CircularStartQuizButton,
  CircularCheckmarkQuizButton,
  CheckMarkSVG,
};
